module.exports = __webpack_public_path__ + "static/media/054-woman-13.fb9d781f.svg";